import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tab, TabList, Tabs, TabPanel } from '../../../v4/components';
import SrnView from './View';
import { breadCrumbConfig, filterConfig, SRN_TABS, tabMapper } from './config';
import PageHeader from '../../base/PageHeader';
import { salesReturn } from '../../common/DomainConfig';
import * as queryService from '../../base/query.service';
import { PanelStyled } from '../../common/configuration';
import { ALERT_TYPE } from '../../../data/enums/AlertType';
import { getPermissionForSrn } from '../../base/permission';
import withAlert from '../../../utils/composition/withAlert';
import { SRN_CREATE, SRN_DETAILS, SRN_PENDING } from '../../../data/enums/Route';
import { EVENT_OPERATION } from '../../../data/enums/EventOperation';
import { apiFilterProcessor, getOffsetFromPagination } from '../../../utils/api';
import { fetchFromLocalStorage, getSortValueAfterValueCheck, imageSliderListFormatter, isError, storeInLocalStorage } from '../../common/HelperFunctions';
import { DOWNLOAD_DOMAIN } from '../../../data/enums/GraphQL';
import Pending from './pending';
import { getUser } from '../../../data/services';
import { clone } from '../../../utils/objectProcessor';
import { storageKeys } from '../orderProcessing/config';
import { DOMAIN } from '../../../data/enums/config';

const propTypes = {
  getSrnList: PropTypes.func.isRequired,
  displayAlert: PropTypes.func.isRequired,
  serverResponseWaiting: PropTypes.bool,
  history: PropTypes.instanceOf(Object).isRequired,
  downloadReport: PropTypes.func,
};

const defaultProps = {
  serverResponseWaiting: false,
  downloadReport: () => null,
};
class Srn extends Component {
  constructor(props) {
    super(props);
    const userData = getUser();
    const logisticEnabled = userData.Distributor.length > 0 && userData.Distributor[0].servicesUsed.logistic.status;
    queryService.resetBaseQueryParameters();
    this.filterConfigMenu = clone(filterConfig.menu);
    this.state = {
      data: {
        list: [],
        total: 0,
      },
      display: {
        searchBox: false,
      },
      queryParameters: {
        pagination: queryService.baseQueryParameters.pagination,
        search: queryService.baseQueryParameters.search,
        sort: {},
        filter: queryService.baseQueryParameters.filter,
        date: { ...queryService.baseQueryParameters.date },
      },
      filterMenu: this.filterConfigMenu || {},
      logisticEnabled,
      activeTab: logisticEnabled ? 0 : 1,
    };
    this.permission = getPermissionForSrn();

    this.basePaginationService = new queryService.QueryClass(
      this.setQueryParameters,
      this.getQueryParameters,
      this.loadTableData,
      props.downloadReport,
      props.displayAlert,
    );

    this.tabListGetterMapper = {
      [SRN_TABS.PENDING]: this.loadTableData,
      [SRN_TABS.SRN]: this.loadTableData,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  setFilterStateInStorage = () => {
    const { filterMenu, queryParameters: { filter, date, search } } = this.state;

    storeInLocalStorage(
      storageKeys.FILTER,
      {
        filter,
        filterMenu,
        date,
        search,
      },
      DOMAIN.SRN
    );
  };

  componentDidMount() {
    this.getFilterStateFromStorage();
  }

  getFilterStateFromStorage = () => {
    const localData = fetchFromLocalStorage(storageKeys.FILTER, DOMAIN.SRN);
    const newFilterConfig = {
      ...localData || {
        filter: { ...filterConfig.instance },
        filterMenu: { ...filterConfig.menu },
        searchText: '',
      },
    };

    if (!localData) {
      return this.getInitialData();
    }

    this.setState(
      {
        ...this.state,
        queryParameters: {
          ...this.state.queryParameters,
          filter: newFilterConfig.filter,
          searchText: newFilterConfig.searchText,
          date: newFilterConfig.date,
        },
        filterMenu: newFilterConfig.filterMenu,
      },
      () => {
        this.getInitialData();
      },
    );
  };

  getInitialData = () => {
    this.loadTableData();
    const { activeTab } = this.state;
    this.fetchActiveTabPaginatedList(activeTab);
  };

  fetchActiveTabPaginatedList = tab => {
    const type = tabMapper[tab];
    this.tabListGetterMapper[type]();
  };

  loadTableData = () => {
    const { data, queryParameters, activeTab } = this.state;
    const { getSrnList, displayAlert } = this.props;
    const offset = getOffsetFromPagination(queryParameters.pagination);
    this.setFilterStateInStorage();
    getSrnList(
      {
        offset,
        limit: queryParameters.pagination.limit,
        filter: {
          filters: [
            ...apiFilterProcessor(queryParameters.filter),
            {
              column: 'status',
              value: activeTab === 0 ? 'PENDING' : 'APPROVED',
            },
          ],
          dateRange: queryParameters.date,
          queryString: queryParameters.search,
          sort: getSortValueAfterValueCheck(queryParameters.sort),
        },
      },
      {
        handleSuccess: response => {
          const dataList = response.data.salesReturnNotes ? response.data.salesReturnNotes.rows : [];
          data.total = response.data.salesReturnNotes ? response.data.salesReturnNotes.count : 1;
          data.list = dataList.map(srn => {
            if (srn.image) {
              srn.image = [...(imageSliderListFormatter(srn.image) || [])];
            }
            return srn;
          });
          if (isError(response)) this.onAPIRequestFailure(response.errors[0]);
          this.setState(data);
        },
        handleError: error => {
          displayAlert(ALERT_TYPE.DANGER, error);
        },
      },
    );
  };

  setQueryParameters = (queryParams, callBack = () => null) =>
    this.setState({ queryParameters: queryParams }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;

    return queryParameters;
  };

  onAPIRequestFailure = error => {
    const { displayAlert } = this.props;
    displayAlert(ALERT_TYPE.DANGER, error);
  };

  handleIconClick = (type, id) => {
    const { history } = this.props;

    switch (type) {
      case EVENT_OPERATION.CREATE:
        history.push(`/${SRN_CREATE}`);
        break;
      case EVENT_OPERATION.APPROVE:
        history.push(`/${SRN_PENDING}/${id}`);
        break;

      default:
        history.push(`/${SRN_DETAILS}/${id}`);
    }
  };

  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;
    this.setState(display);
  };

  handleTabChange = tab => {
    this.setState(
      {
        activeTab: tab,
      },
      () => this.fetchActiveTabPaginatedList(tab),
    );
  };

  render() {
    const { data, queryParameters, display, activeTab, logisticEnabled, filterMenu } = this.state;
    const { serverResponseWaiting } = this.props;

    return (
      <Fragment>
        <div className="section-header">
          <PanelStyled>
            <PageHeader
              display={display}
              breadCrumb={breadCrumbConfig}
              config={{
                title: salesReturn.title,
                create: this.permission.create,
                download: true,
                filter: true,
                date: true,
                search: true,
              }}
              downloadConfig={{
                domain: DOWNLOAD_DOMAIN.SALES_RETURN_REPORT,
              }}
              filter={{
                date: queryParameters.date,
                menuList: filterMenu,
                onFilterChange: this.basePaginationService.handleFilterChange,
              }}
              queryParameters={queryParameters}
              controlDisplay={this.controlDisplay}
              handleCreateClick={this.handleIconClick}
              resetFilter={this.basePaginationService.resetFilter}
              clearSearchText={this.basePaginationService.clearSearchText}
              handleSearchChange={this.basePaginationService.handleSearchInputChange}
              handleDateRangeChange={this.basePaginationService.handleDateRangeChange}
              handleDownloadClick={this.basePaginationService.handleDownloadClick}
            />
          </PanelStyled>
        </div>
        <div className={`section-content ${logisticEnabled ? 'section-tab' : ''} table-present`}>
          <Tabs selectedIndex={activeTab} onSelect={tabIndex => this.handleTabChange(tabIndex)}>
            {logisticEnabled && (
              <TabList>
                <Tab>
                  <span className="tab-label">Pending</span>
                </Tab>
                <Tab>
                  <span className="tab-label">SRN</span>
                </Tab>
              </TabList>
            )}
            <div className="tab-container">
              <TabPanel>
                <section id="pending-tab">
                  <div id="detail-tab">
                    <div className="create-ui-inner tab-less-height" style={{ padding: '0' }}>
                      <Pending
                        data={data}
                        loading={serverResponseWaiting}
                        pagination={queryParameters.pagination}
                        onRowClick={this.handleIconClick}
                        onPageChange={this.basePaginationService.onPageSelect}
                      />
                    </div>
                  </div>
                </section>
              </TabPanel>
              <TabPanel>
                <section id="received-tab">
                  <div id="detail-tab">
                    <div className="create-ui-inner tab-less-height" style={{ padding: '0' }}>
                      <SrnView
                        data={data}
                        loading={serverResponseWaiting}
                        pagination={queryParameters.pagination}
                        onRowClick={this.handleIconClick}
                        onPageChange={this.basePaginationService.onPageSelect}
                        onHeaderClick={this.basePaginationService.handleTableSorting}
                      />
                    </div>
                  </div>
                </section>
              </TabPanel>
            </div>
          </Tabs>
        </div>
      </Fragment>
    );
  }
}

Srn.propTypes = propTypes;

Srn.defaultProps = defaultProps;

export default withAlert()(Srn);
